import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { ISchedule, IManagerDashboardState } from './type';

const initialState: IManagerDashboardState = {
  addSchedule: {},
  schedules: {},
  updateScheduleStatus: {},
};
const slice = createSlice({
  name: 'managerDashboard',
  initialState,
  reducers: {
    addSchedule(state, action: PayloadAction<ISchedule>) {
      state.addSchedule.status = RequestStatus.RUNNING;
    },
    addScheduleSuccess(state, action: PayloadAction<ISchedule>) {
      state.addSchedule.status = RequestStatus.SUCCESS;
      state.addSchedule.data = action.payload;
    },
    addScheduleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addSchedule.status = RequestStatus.ERROR;
      state.addSchedule.error = action.payload;
    },
    //
    getSchedule(state) {
      state.schedules.status = RequestStatus.RUNNING;
    },
    getScheduleSuccess(state, action: PayloadAction<IManagerDashboardState['schedules']['data']>) {
      state.schedules.status = RequestStatus.SUCCESS;
      state.schedules.data = action.payload;
    },
    getScheduleFailed(state, action: PayloadAction<IRequestFailed>) {
      state.schedules.status = RequestStatus.ERROR;
      state.schedules.error = action.payload;
    },
    //
    updateScheduleStatus(state, action: PayloadAction<any>) {
      state.updateScheduleStatus.status = RequestStatus.RUNNING;
    },
    updateScheduleStatusSuccess(state, action: PayloadAction<ISchedule>) {
      state.updateScheduleStatus.status = RequestStatus.SUCCESS;
      state.updateScheduleStatus.data = action.payload;
    },
    updateScheduleStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateScheduleStatus.status = RequestStatus.ERROR;
      state.updateScheduleStatus.error = action.payload;
    },
  },
});
export default slice.reducer;
export const {
  addSchedule,
  addScheduleFailed,
  addScheduleSuccess,
  getSchedule,
  getScheduleFailed,
  getScheduleSuccess,
  updateScheduleStatus,
  updateScheduleStatusFailed,
  updateScheduleStatusSuccess,
} = slice.actions;
